module.exports = __webpack_public_path__ + "static/img/zhijian.71d8a599.png";